/**
 * Native ES module produced from the historical shared-scope controller.
 * Cross-domain dependencies are explicit imports; eager DOM wiring is isolated in the init function.
 */
import { applyI18n, i18nReady } from '../../platform/i18n/index.js';
import { enterApp, glassFlowActive, glassFlowHold, isGlassFlow, leaveApp, setGlassFlow, setGlassFlowHold } from '../onboarding/onboarding.runtime.js';
import { syncAndroidAccessToken, wireAndroidBridgeUi } from './android-uikit.runtime.js';
import { $, $$, api, clearAppBoot, cookie, enterInviteGuest, escapeHTML, initAuthGroupDiscovery, initAuthTeacherDiscovery, isAppBootActive, loadInvitePreview, parseDeepLink, refreshSession, revealAuthFromBoot, revealInviteAuthFromJoin, setAppBootSplash, setAuthError, setSessionHint, showLegalPage, state, superGrokMode, syncInviteBanner, t, toast } from './core.runtime.js';
import { consumeTelegramAuthError, handlePasswordResetLink, initTelegramLogin, loadBase } from '../session/session.runtime.js';
import { applyChronicleInitials, applyInterfaceMode, closeOrbSheet, confirmAction, enterGlassShell, options, renderView } from '../shell/navigation.runtime.js';
import { wireAISourcePickers } from '../study/homework-ai.runtime.js';

export function openOrganizationForm(type,item,data){
  let body='';
  if(type==='university')body=`<label>Название<input name="name" required value="${escapeHTML(item?.name||'')}"></label><label>Краткое название<input name="short_name" required value="${escapeHTML(item?.short_name||'')}"></label><label>Часовой пояс<input name="timezone" required value="${escapeHTML(item?.timezone||'Europe/Moscow')}"></label>`;
  if(type==='institute')body=`<label>Университет<select name="university_id" required>${options(data.universities,'id',v=>v.short_name)}</select></label><label>Название<input name="name" required value="${escapeHTML(item?.name||'')}"></label><label>Краткое название<input name="short_name" required value="${escapeHTML(item?.short_name||'')}"></label><label>Описание<textarea name="description">${escapeHTML(item?.description||'')}</textarea></label>`;
  if(type==='program')body=`<label>Институт<select name="institute_id" required>${options(data.institutes,'id',v=>v.short_name)}</select></label><label>Код<input name="code" value="${escapeHTML(item?.code||'')}"></label><label>Название<input name="name" required value="${escapeHTML(item?.name||'')}"></label><div class="dialog-grid"><label>Уровень<input name="education_level" required value="${escapeHTML(item?.education_level||'specialist')}"></label><label>Форма<input name="study_form" required value="${escapeHTML(item?.study_form||'full_time')}"></label></div>`;
  if(type==='group')body=`<label>Программа<select name="academic_program_id" required>${options(data.programs,'id',v=>`${v.code||''} ${v.name}`)}</select></label><label>Название<input name="name" required value="${escapeHTML(item?.name||'')}"></label><div class="dialog-grid"><label>Год поступления<input name="admission_year" type="number" min="2000" max="2200" value="${item?.admission_year||new Date().getFullYear()}" required></label><label>Курс<input name="current_course" type="number" min="1" max="8" value="${item?.current_course||1}" required></label></div>`;
  body+=`<label>Статус<select name="status"><option value="active">Активно</option><option value="archived">Архив</option></select></label>`;
  const deleteLabel={university:'ВУЗ',institute:'институт',program:'программу',group:'группу'}[type]||'объект';
  const deleteWarning=type==='university'?`Удалить ВУЗ «${item?.short_name||item?.name||''}» НАВСЕГДА? Будут удалены его институты, программы, группы, расписание и связанные данные. Отменить это нельзя.`:type==='institute'?`Удалить институт «${item?.short_name||item?.name||''}» НАВСЕГДА вместе с программами и группами?`:type==='program'?`Удалить программу «${item?.name||''}» НАВСЕГДА вместе с группами и связанными данными?`:`Удалить группу «${item?.name||''}» НАВСЕГДА вместе с расписанием и групповыми данными?`;
  const buttons=[{label:'Отмена',action:closeDialog}];
  if(item)buttons.push({label:'Удалить навсегда',danger:true,action:async()=>{
    if(!confirmAction(deleteWarning))return;
    const plural={university:'universities',institute:'institutes',program:'programs',group:'groups'}[type];
    // Keep the DELETE request separate from the post-delete refresh. Previously
    // loadBase() ran in the same action chain, so a later /groups or /roles/me
    // failure looked to the user exactly like the destructive request itself had
    // returned 500 even when the row was already gone.
    await api(`/admin/${plural}/${item.id}`,{method:'DELETE'});
    toast(`${deleteLabel} удалён навсегда`);
    state.groups=[];state.subgroups=[];state.adminOrgSelection='';state.adminSelectedGroupID='';
    closeDialog();
    try{await loadBase();}catch(refreshError){console.error('post-delete state refresh failed',refreshError);localStorage.removeItem('kuni-group-id');state.groupID='';}
    renderView();
  }});
  buttons.push({label:'Сохранить',primary:true,action:async()=>{const f=$('#org-form');if(!f.reportValidity())return;const d=Object.fromEntries(new FormData(f));if(type==='group'){d.admission_year=Number(d.admission_year);d.current_course=Number(d.current_course);}if(type==='program'&&!d.code)d.code=null;const map={university:['universities','universities'],institute:['institutes','institutes'],program:['programs','programs'],group:['groups','groups']}[type];await api(item?`/admin/${map[1]}/${item.id}`:`/admin/${map[0]}`,{method:item?'PATCH':'POST',body:JSON.stringify(d)});toast('Структура сохранена');state.groups=[];await loadBase();closeDialog();renderView();}});
  openDialog(`${item?'Изменить':'Создать'} ${type}`,`<form class="form" id="org-form">${body}</form>`,buttons);
  const f=$('#org-form');
  if(item){
    if(f.elements.university_id)f.university_id.value=item.university_id;
    if(f.elements.institute_id)f.institute_id.value=item.institute_id;
    if(f.elements.academic_program_id)f.academic_program_id.value=item.academic_program_id;
    f.status.value=item.status||'active';
  }else if(state.adminOrgSelection){
    const [selectedType,selectedID]=state.adminOrgSelection.split(':');
    if(type==='institute'&&selectedType==='university'&&f.elements.university_id)f.elements.university_id.value=selectedID;
    if(type==='program'&&selectedType==='institute'&&f.elements.institute_id)f.elements.institute_id.value=selectedID;
    if(type==='group'&&selectedType==='program'&&f.elements.academic_program_id)f.elements.academic_program_id.value=selectedID;
  }
}

async function openCatalogManager(){
  const [teachers,subjects,rooms]=await Promise.all([api('/catalog/teachers?include_archived=true'),api('/catalog/subjects?include_archived=true'),api('/catalog/rooms?include_archived=true')]);
  openDialog('Справочники',`<div class="section-label">Предметы</div><div class="list">${subjects.map(v=>catalogRow('subject',v,v.name,v.short_name)).join('')}</div><div class="section-label">Преподаватели</div><div class="list">${teachers.map(v=>catalogRow('teacher',v,v.full_name,v.email)).join('')}</div><div class="section-label">Аудитории</div><div class="list">${rooms.map(v=>catalogRow('room',v,`${v.building} ${v.room}`,v.address)).join('')}</div>`,[{label:'+ Предмет',action:()=>openCatalogForm('subject')},{label:'+ Преподаватель',action:()=>openCatalogForm('teacher')},{label:'+ Аудитория',primary:true,action:()=>openCatalogForm('room')}]);
  const all={subject:subjects,teacher:teachers,room:rooms};$$('.catalog-entity').forEach(b=>b.addEventListener('click',()=>openCatalogForm(b.dataset.type,all[b.dataset.type].find(v=>v.id===b.dataset.id))));
}

function catalogRow(type,v,title,sub){return `<button class="row clickable catalog-entity" type="button" data-type="${type}" data-id="${v.id}"><div class="row-main"><strong>${escapeHTML(title)}</strong><p>${escapeHTML(sub||'')}</p></div><div class="row-end">${escapeHTML(v.status||'active')}</div></button>`;}

export async function openCatalogForm(type,item=null){
  const org=await api('/admin/organization?include_archived=true');let body='';
  if(type==='teacher')body=`<label>ФИО<input name="full_name" required value="${escapeHTML(item?.full_name||'')}"></label><label>Короткое имя<input name="short_name" value="${escapeHTML(item?.short_name||'')}"></label><label>Email<input type="email" name="email" value="${escapeHTML(item?.email||'')}"></label><label>Институт<select name="institute_id"><option value="">Не указан</option>${options(org.institutes,'id',v=>v.short_name)}</select></label>`;
  if(type==='subject')body=`<label>Название<input name="name" required value="${escapeHTML(item?.name||'')}"></label><label>Короткое название<input name="short_name" value="${escapeHTML(item?.short_name||'')}"></label><label>Программа<select name="academic_program_id"><option value="">Общий предмет</option>${options(org.programs,'id',v=>`${v.code||''} ${v.name}`)}</select></label>`;
  if(type==='room')body=`<label>Университет<select name="university_id" required>${options(org.universities,'id',v=>v.short_name)}</select></label><div class="dialog-grid"><label>Корпус<input name="building" required value="${escapeHTML(item?.building||'')}"></label><label>Аудитория<input name="room" required value="${escapeHTML(item?.room||'')}"></label></div><label>Адрес<input name="address" value="${escapeHTML(item?.address||'')}"></label><label>Вместимость<input name="capacity" type="number" min="1" value="${item?.capacity||''}"></label>`;
  body+='<label>Статус<select name="status"><option value="active">Активно</option><option value="archived">Архив</option></select></label>';
  const catalogButtons=[{label:'Отмена',action:closeDialog}];if(item)catalogButtons.push({label:'Удалить навсегда',danger:true,action:async()=>{const title=type==='teacher'?item.full_name:type==='subject'?item.name:`${item.building} ${item.room}`;const warning=type==='subject'?`Удалить предмет «${title}» НАВСЕГДА? Будут удалены связанные серии/пары расписания, задания, автоматы и записи конспектов. Это необратимо.`:type==='teacher'?`Удалить преподавателя «${title}» НАВСЕГДА? Связанные преподавательские заметки будут удалены, а в расписании преподаватель станет не указан. Это необратимо.`:`Удалить аудиторию «${title}» НАВСЕГДА? В связанных парах аудитория станет не указана. Это необратимо.`;if(!confirmAction(warning))return;const plural={teacher:'teachers',subject:'subjects',room:'rooms'}[type];await api(`/admin/catalog/${plural}/${item.id}`,{method:'DELETE'});state.catalogs={subjects:[],teachers:[],rooms:[]};closeDialog();toast('Объект удалён навсегда');renderView();}});catalogButtons.push({label:'Сохранить',primary:true,action:async()=>{const f=$('#catalog-form');if(!f.reportValidity())return;const d=Object.fromEntries(new FormData(f));['institute_id','academic_program_id'].forEach(k=>{if(k in d&&!d[k])d[k]=null;});if('capacity'in d)d.capacity=d.capacity?Number(d.capacity):null;const plural={teacher:'teachers',subject:'subjects',room:'rooms'}[type];await api(item?`/admin/catalog/${plural}/${item.id}`:`/admin/catalog/${plural}`,{method:item?'PATCH':'POST',body:JSON.stringify(d)});state.catalogs={subjects:[],teachers:[],rooms:[]};closeDialog();toast('Справочник сохранён');renderView();}});openDialog(`${item?'Изменить':'Создать'} ${type}`,`<form class="form" id="catalog-form">${body}</form>`,catalogButtons);const f=$('#catalog-form');if(item){if(f.institute_id)f.institute_id.value=item.institute_id||'';if(f.academic_program_id)f.academic_program_id.value=item.academic_program_id||'';if(f.university_id)f.university_id.value=item.university_id||'';f.status.value=item.status||'active';}
}

var dialogEpoch = 0;

export function dialogSessionActive(epoch) {
  const dialog = $('#dialog');
  return Boolean(dialog?.open) && Number(dialog.dataset.epoch || 0) === Number(epoch);
}

export function openDialog(title, bodyHTML, buttons = []) {
  const dialog = $('#dialog');
  const epoch = ++dialogEpoch;
  dialog.dataset.epoch = String(epoch);
  dialog.returnValue = '';
  const keepGlass = glassFlowActive || glassFlowHold || (dialog.open && dialog.classList.contains('sg-orb-dialog'));
  const wasGlassOpen = dialog.open && dialog.classList.contains('sg-sheet-open');
  dialog.classList.remove(
    'x10-actions-dialog', 'onboarding-dialog', 'sg-orb-dialog', 'global-search-dialog',
    'sg-sheet-dialog', 'sg-sheet-open', 'sg-sheet-closing', 'sg-sheet-drag',
    'sg-glass-form', 'sg-glass-menu',
  );
  dialog.style.removeProperty('--sg-sheet-y');
  // Prevent opacity flash while swapping body inside an open glass stage.
  if (wasGlassOpen && keepGlass) {
    dialog.classList.add('sg-orb-dialog', 'sg-sheet-dialog', 'sg-sheet-open');
  }
  if (!keepGlass) document.body.classList.remove('sg-sheet-active');
  const header = dialog.querySelector('header');
  if (header) header.hidden = false;
  $('#dialog-title').textContent = title;
  const kicker = dialog.querySelector('.dialog-kicker');
  if (kicker) { kicker.hidden = false; kicker.textContent = 'kUni'; }
  const body = $('#dialog-body');
  body.innerHTML = bodyHTML;
  body.scrollTop = 0;
  if (typeof applyChronicleInitials === 'function') applyChronicleInitials();
  const footer = $('#dialog-footer'); footer.hidden = false; footer.replaceChildren();
  buttons.forEach((config) => {
    const button = document.createElement('button');
    button.type = config.type || 'button';
    button.className = `button ${config.primary ? 'primary' : ''} ${config.danger ? 'danger' : ''}`;
    button.textContent = config.label;
    button.disabled = !!config.disabled;
    if (config.form) button.setAttribute('form', config.form);
    if (config.action) button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      try { await config.action(); }
      catch (error) { console.error(error); toast(error?.message || t('common.error.action'), 'err'); }
    });
    footer.append(button);
  });
  if (!dialog.open) {
    try { dialog.showModal(); }
    catch (error) {
      // Firefox can briefly leave a reused <dialog> in a stale top-layer state.
      // Reset the open attribute and retry once on the next frame instead of
      // leaving the global + menu dead until a full page reload.
      console.warn('dialog showModal retry', error);
      dialog.removeAttribute('open');
      requestAnimationFrame(() => {
        if (Number(dialog.dataset.epoch || 0) !== epoch || dialog.open) return;
        try { dialog.showModal(); } catch (retryError) { console.error('dialog showModal failed', retryError); }
      });
    }
  }
  // SuperGrok / glass-flow: secondary surfaces share one frosted stage.
  // Security gates + onboarding keep standard dialog chrome.
  const isMenu = Boolean(body.querySelector?.('.sg-orb-sheet'));
  const security = dialog.dataset.securityLocked === 'true';
  const isOnboarding = dialog.classList.contains('onboarding-dialog');
  if (!security && !isOnboarding && (keepGlass || glassFlowHold || glassFlowActive || superGrokMode())) {
    setGlassFlow(true);
    setGlassFlowHold(false);
    enterGlassShell({ menu: isMenu, showOrb: isMenu });
  }
  requestAnimationFrame(()=>wireAISourcePickers(dialog));
  return epoch;
}

export function closeDialog() {
  const dialog = $('#dialog');
  if (!dialog?.open) return;
  // Orb / bottom-sheet: animate out before closing the top-layer dialog.
  if (dialog.classList.contains('sg-orb-dialog') || dialog.classList.contains('sg-sheet-dialog')) {
    if (!dialog.classList.contains('sg-sheet-closing')) closeOrbSheet();
    return;
  }
  dialog.close();
}

export function transitionDialog(action) {
  const dialog = $('#dialog');
  // Preserve glass stage when swapping orb menus → add → forms.
  if (isGlassFlow() || glassFlowHold) {
    setGlassFlow(true);
    setGlassFlowHold(true);
  }
  let fired = false;
  const run = () => {
    if (fired) return;
    fired = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      try {
        const result = action?.();
        if (result?.catch) result.catch((error) => { console.error(error); toast(error?.message || t('common.error.action')); });
      } catch (error) {
        console.error(error);
        toast(error?.message || t('common.error.action'));
      }
    }));
  };
  if (!dialog?.open) { run(); return; }
  dialog.addEventListener('close', run, { once:true });
  // Skip closeOrbSheet animation — hard close for content swap inside glass flow.
  if (dialog.classList.contains('sg-orb-dialog') || dialog.classList.contains('sg-sheet-dialog')) {
    dialog.classList.remove('sg-sheet-open', 'sg-sheet-closing', 'sg-sheet-drag');
    dialog.close();
    return;
  }
  dialog.close();
}

function dialogClickShouldDismiss(event) {
  const dialog = $('#dialog');
  if (!dialog?.open) return false;
  if (dialog.dataset.securityLocked === 'true') return false;
  if (dialog.classList.contains('onboarding-dialog')) return false;
  if (dialog.classList.contains('sg-sheet-drag') || dialog.classList.contains('sg-sheet-closing')) return false;
  const target = event.target;
  if (!target || (target !== dialog && !dialog.contains(target))) return false;
  if (target.closest([
    'button', 'a', 'input', 'textarea', 'select', 'option', 'label', 'summary',
    '[role="menuitem"]', '[role="option"]', '[role="tab"]', '[role="switch"]',
    '[role="checkbox"]', '[role="radio"]', '[contenteditable="true"]',
    '.sg-orb-action', '.sg-orb-stay',
    '.global-search-result', '.global-search-field', '.global-search-hints',
    '.lesson-picker-search', '.lesson-picker-list', '.lesson-picker-schedule', '.lesson-auto-button',
    '.row.clickable', '.x10-row', '.settings-link',
    '.form', '.x10-form', '.ai-source-option',
    'footer',
  ].join(','))) return false;
  return true;
}

async function boot() {
  try {
    const lastMode = localStorage.getItem('kuni-last-interface-mode');
    if (lastMode) applyInterfaceMode(lastMode);
  } catch { /* ignore */ }
  try { await i18nReady(); } catch (error) { console.warn('ui text dictionary failed to initialize', error); }
  applyI18n(document);
  if (state.deepLink?.type === 'legal') {
    await showLegalPage(state.deepLink.document);
    return;
  }

  // Suppress auth for the whole app when a session is likely OR /join is opening.
  // Head script already did this for first paint; re-assert in case of partial state.
  const expectSession = (() => {
    try {
      const csrf = cookie('kuni_csrf');
      if (csrf) return true;
    } catch { /* ignore */ }
    try { return localStorage.getItem('kuni-session-hint') === '1'; } catch { return false; }
  })();
  if (state.pendingInviteCode) {
    setAppBootSplash('join');
    const box = $('.auth-box');
    if (box) {
      box.dataset.authStage = 'invite';
      document.body.dataset.authStage = 'invite';
    }
  } else if (expectSession || isAppBootActive()) {
    setAppBootSplash('session');
  }
  syncInviteBanner();
  initAuthGroupDiscovery();
  initAuthTeacherDiscovery();
  consumeTelegramAuthError();
  initTelegramLogin();
  window.addEventListener('online', () => {
    document.documentElement.classList.remove('kuni-offline');
    document.documentElement.dataset.kuniOffline = '0';
    $('#connection-state').textContent = t('shell.sync.ok');
    syncAndroidAccessToken();
  });
  window.addEventListener('offline', () => {
    document.documentElement.classList.add('kuni-offline');
    document.documentElement.dataset.kuniOffline = '1';
    $('#connection-state').textContent = t('shell.sync.offline');
  });
  if (!navigator.onLine) {
    document.documentElement.classList.add('kuni-offline');
    document.documentElement.dataset.kuniOffline = '1';
    $('#connection-state').textContent = t('shell.sync.offline');
  }
  wireAndroidBridgeUi();
  syncAndroidAccessToken();
  if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).then((registration) => registration.update()).catch(() => {});

  // Telegram password-reset links must work before a session exists.
  const initialLink = state.deepLink || parseDeepLink();
  if (initialLink?.type === 'reset-password' && initialLink.token) {
    clearAppBoot();
    await handlePasswordResetLink(initialLink.token);
    return;
  }

  // Session + invite preview in parallel so join/session open as soon as both settle.
  let hasSession = false;
  try {
    const sessionPromise = refreshSession().catch(() => false);
    const previewPromise = state.pendingInviteCode ? loadInvitePreview() : Promise.resolve(null);
    const [sessionOk] = await Promise.all([sessionPromise, previewPromise]);
    hasSession = Boolean(sessionOk);
  } catch {
    hasSession = false;
  }

  try {
    if (hasSession) {
      state.__inviteBootError = '';
      setSessionHint(true);
      await enterApp();
      return;
    }
    // Stale session hint / expired cookie — never keep the hint after a failed refresh.
    setSessionHint(false);

    // Unauthenticated /join → open the group as guest immediately (value first).
    if (state.pendingInviteCode && state.invitePreview?.group) {
      try {
        await enterInviteGuest({ quiet: false });
        return;
      } catch (error) {
        revealInviteAuthFromJoin();
        setAuthError(error?.message || 'Не удалось открыть группу');
        return;
      }
    }
    // Still under boot overlay — leave cover for a real screen once, never flash mid-boot.
    if (isAppBootActive()) {
      const bootError = state.__inviteBootError || '';
      state.__inviteBootError = '';
      if (bootError) {
        revealAuthFromBoot('welcome');
        syncInviteBanner();
        setAuthError(bootError);
        return;
      }
      if (state.pendingInviteCode) {
        revealInviteAuthFromJoin();
        return;
      }
      // Expected a session but refresh failed → show auth only now.
      revealAuthFromBoot(state.pendingInviteCode ? 'invite' : 'welcome');
      return;
    }
  } catch {
    setSessionHint(false);
    if (isAppBootActive() || state.pendingInviteCode) {
      if (state.pendingInviteCode) revealInviteAuthFromJoin();
      else revealAuthFromBoot('welcome');
    } else leaveApp();
  }
}

export function initDialogBootRuntime() {
  $('#dialog-close').addEventListener('click', closeDialog);

  $('#dialog').addEventListener('click', (event) => {
    if (dialogClickShouldDismiss(event)) closeDialog();
  });

  $('#dialog').addEventListener('close', () => {
    const dialog = $('#dialog');
    dialogEpoch += 1;
    dialog.dataset.epoch = String(dialogEpoch);
    dialog.classList.remove('x10-actions-dialog', 'sg-orb-dialog', 'sg-sheet-dialog', 'sg-sheet-open', 'sg-sheet-closing', 'sg-sheet-drag', 'sg-glass-form', 'sg-glass-menu');
    dialog.style.removeProperty('--sg-sheet-y');
    // If a glass transition is about to reopen the dialog, keep flow/dock state briefly.
    if (!glassFlowHold) {
      document.body.classList.remove('sg-sheet-active');
      $('#sg-orb')?.classList.remove('is-open');
      setGlassFlow(false);
    }
    const header = dialog.querySelector('header');
    if (header) header.hidden = false;
    dialog.removeAttribute('aria-busy');
    const body = $('#dialog-body');
    if (body) body.scrollTop = 0;
    if (dialog.dataset.securityLocked !== 'true') $('#dialog-close').hidden = false;
    const toastNode = $('#toast');
    if (toastNode && toastNode.parentElement !== document.body) document.body.append(toastNode);
    // Drop hold if nothing reopened on the next frames.
    if (glassFlowHold) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!$('#dialog')?.open) {
          setGlassFlowHold(false);
          setGlassFlow(false);
          document.body.classList.remove('sg-sheet-active');
          $('#sg-orb')?.classList.remove('is-open');
        }
      }));
    }
  });

  return boot();
}
